import { Review } from "./types";

export const initialReview: Review = {
  id: -1,
  title: "",
  metaDescription: "",
  metaTitle: "",
  slug: "",
  content: "",
  image: null,
  published: false,
  createdAt: new Date(),
  updatedAt: new Date(),
};
